import * as React from "react";

import * as serviceWorkerRegistration from "../../serviceWorkerRegistration";

function UpdatePWA() {
  React.useEffect(() => {
    serviceWorkerRegistration.unregister();
  }, []);
  return null as any;
}
export default UpdatePWA;
